import { createContext, useContext, useState } from "react";
import { supabase } from "../supabase/client";

export let UserContext = createContext();

export let useUser = () => {
  let context = useContext(UserContext);
  return context;
};

export let UserContextProvider = ({ children }) => {
  let [user, setUser] = useState(null);
  let [userObject, setUserObject] = useState(null);
  let [isSession, setIsSession] = useState(null);
  let [loadingSession, setLoadingSession] = useState(false);
  let [posts, setPosts] = useState([]);
  let [likedPosts, setLikedPosts] = useState([]);
  let [loadingLikes, setLoadingLikes] = useState(false);
  let [lastLikeDeleted, setLastLikeDeleted] = useState("");
  let [changer, setChanger] = useState(false);
  let [fetchedLikes, setFetchedLikes] = useState(false);
  let [loadingPosts, setLoadingPosts] = useState(false);
  let [currValueLiked, setCurrValueLiked] = useState(null);
  let [voteUpdating, setVoteUpdating] = useState(false);
  let testing = () => {
    console.log("Does this shirt work?");
  };

  let getSession = async () => {
    setLoadingSession(true);
    try {
      let sessionActive = await supabase.auth.getSession();
      let userActive = sessionActive.data.session.user;
      setIsSession(userActive);
    } catch {
      console.log("error");
    }
    setLoadingSession(false);
  };

  //

  let getPosts = async () => {
    setLoadingPosts(true);
    const { data, error } = await supabase
      .from("main-facts")
      .select()
      .order("created_at", { ascending: false });

    if (error) throw error;

    console.log(data);
    setPosts(data);
    setChanger(true);
    console.log(changer);
    setLoadingPosts(false);
  };

  let handleLikePost = async (userId, postId) => {
    let { data, error } = await supabase
      .from("likes")
      .insert({ user_id: userId, post_id: postId })
      .select();
    console.log(data);

    if (error) throw error;

    console.log(data);
    setLikedPosts([...likedPosts, ...data]);
  };
  //

  let deleteLikePost = async (postId) => {
    try {
      const { data, error } = await supabase
        .from("likes")
        .delete()
        .eq("post_id", postId)
        .select();
      setLastLikeDeleted(data);
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setFetchedLikes(true);
    }
  };
  //

  let fetchLikes = async (userId, postId) => {
    setLoadingLikes(true);

    const { data: likes, error } = await supabase
      .from("likes")
      .select("user_id, post_id")
      .eq("user_id", userId);

    if (error) throw error;

    setLikedPosts(likes);
    setFetchedLikes(true);
  };

  let updateLikePost = async (postId, postlikes, action) => {
    try {
      setVoteUpdating(true);

      //
      const { data: currentPostLiked, error } = await supabase
        .from("main-facts")
        .select("*")
        .eq("id", postId)
        .single();

      if (error) {
        console.error(error);
        return;
      }

      //
      let { data, error: updateError } = await supabase
        .from("main-facts")
        .update(
          action
            ? { like: currentPostLiked.like + 1 }
            : { like: currentPostLiked.like - 1 }
        )
        .eq("id", postId)
        .select();
      console.log(data[0]);
      setCurrValueLiked(
        action ? `${currentPostLiked.like + 1}` : `${currentPostLiked.like - 1}`
      );
      setVoteUpdating(false);
    } catch (updateError) {
      console.log(updateError);
    } finally {
      console.log("WORK");
      console.log(voteUpdating);
    }
  };

  //ALL WORKS WELL HERE
  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        testing,
        getSession,
        isSession,
        setIsSession,
        loadingSession,
        userObject,
        setUserObject,
        getPosts,
        posts,
        setPosts,
        handleLikePost,
        fetchLikes,
        likedPosts,
        loadingLikes,
        setLoadingLikes,
        deleteLikePost,
        lastLikeDeleted,
        setLastLikeDeleted,
        changer,
        fetchedLikes,
        setLikedPosts,
        loadingPosts,
        updateLikePost,
        voteUpdating,
        setCurrValueLiked,
        currValueLiked,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
